import { render, staticRenderFns } from "./helpdo-view.vue?vue&type=template&id=6ff64edc&scoped=true&"
import script from "./helpdo-view.vue?vue&type=script&lang=js&"
export * from "./helpdo-view.vue?vue&type=script&lang=js&"
import style0 from "./helpdo-view.vue?vue&type=style&index=0&id=6ff64edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff64edc",
  null
  
)

export default component.exports